import { setSidebarContent } from 'features/sidebar/sidebarSlice';

import { useAppDispatch } from 'hooks/useTypedRedux';

import { SidebarContentTypes } from 'constants/enums';

interface UseApplicationActionsProps {
  applicationId?: string;
}

const useApplicationActions = ({
  applicationId
}: UseApplicationActionsProps): {
  sendOfferLetter: () => void;
} => {
  const dispatch = useAppDispatch();

  const sendOfferLetter = () => {
    if (!applicationId) {
      return;
    }
    dispatch(
      setSidebarContent({
        contentId: SidebarContentTypes.OfferView,
        activeUserId: applicationId
      })
    );
  };

  return { sendOfferLetter };
};

export default useApplicationActions;
